import { ProductListItemFragment } from '@graphcommerce/magento-product'

export function gtagViewItem<C extends ProductListItemFragment>(item?: C | null) {
  if (!item) return

  globalThis.dataLayer?.push({ event: 'view_pdp' })
}
